export const MainLayoutStyles = {
  main: (noHorizontalPadding: boolean) =>
    `flex flex-col justify-content-center items-center w-full bg-skyblue100 pt-6 ${
      !noHorizontalPadding ? 'px-8 sm:px-16' : ''
    }`,
}
